

































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import CheckBox from "@/components/CheckBox.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import CarsDTO from "../models/CarsDTO";

interface Data {
  items: CarsDTO[];
  selectedItems: CarsDTO[];
}

interface Props {
  title: string;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

interface Methods {
  selected(item: CarsDTO): void;
  addToSummary(dataItem: CarsDTO): void;
  newCarChanged(item: CarsDTO): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ApiSearchPage, CheckBox },

  props: {
    title: {
      type: String,
      default: "Gépjármű kereső",
    },
  },

  data: () => ({
    items: [],
    selectedItems: [],
  }),

  methods: {
    newCarChanged(item: CarsDTO) {
      item.isNewCar = !item.isNewCar;
    },

    selected(item: CarsDTO) {
      this.$emit("selected", item);
    },

    addToSummary(dataItem: CarsDTO) {
      this.selected(dataItem);
    },
  },

  computed: {
    columns: function() {
      return [
            { field: "brand", title: "Gyártmány" },
            { field: "model", title: "Modell" },
            { field: "color", title: "Szín" },
            { field: "bodyNo", title: "Alvázszám" },
            { field: "engineNo", title: "Motorszám" },
            { field: "regNum", title: "Rendszám" },
            { field: "owner", title: "Tulajdonos" },
            { field: "ownerRunning", title: "Üzembentartó" },
            { field: "carStatusName", title: "Gj. státusz", filterable: false, sortable: false },
            { field: "isNewCar", title: "Új autó?", cell: "isNewCar", filterable: false, sortable: false },
            {field: "id", cell: "selectButton", filterable: false, sortable: false}
          ];
    },

    url() {
      return `bank/cars`;
    },
  },
});
